import BaseRepository from "./BaseRepository";
import { travelersIncludes } from "../../store/dispatchers/members.dispatchers";

export default class MembersRepository extends BaseRepository {
    getEndpoint() {
        return "v1/members";
    }

    me() {
        return this.request("GET", `${this.getEndpoint()}/me`, null);
    }

    getByEmail(email) {
        return this.request(
            "GET",
            `${this.getEndpoint()}/get-by-email/${email}`
        );
    }

    getByEmailWithZinreloData() {
        return this.request(
            "GET",
            `${this.getEndpoint()}/get-by-email-with-zinrelo-data`,
            null
        );
    }

    getRegularTravelers(cursor, includes) {
        const queryString = this.buildQueryString({
            cursor,
            includes,
        });
        return this.request(
            "GET",
            `${this.getEndpoint()}/get-regular-travelers?${queryString}`,
            null
        );
    }

    getRegularTraveler(id, includes) {
        const queryString = this.buildQueryString({
            includes,
        });
        return this.request(
            "GET",
            `${this.getEndpoint()}/get-regular-traveler/${id}?${queryString}`,
            null
        );
    }

    saveMemberLogo(id, data) {
        return this.request(
            "POST",
            `${this.getEndpoint()}/${id}/memberLogo`,
            data
        );
    }

    saveMemberEmail(id, data) {
        return this.request(
            "POST",
            `${this.getEndpoint()}/${id}/memberEmail`,
            data
        );
    }

    updateMemberEmail(id, memberEmailId, data) {
        return this.request(
            "PATCH",
            `${this.getEndpoint()}/${id}/memberEmail/${memberEmailId}`,
            data
        );
    }

    saveMemberPhone(id, data) {
        return this.request(
            "POST",
            `${this.getEndpoint()}/${id}/memberPhone`,
            data
        );
    }

    resetPassword(data) {
        return this.request(
            "POST",
            `${this.getEndpoint()}/resetPassword`,
            data
        );
    }

    savePassword(data) {
        return this.request("POST", `${this.getEndpoint()}/savePassword`, data);
    }

    updateMemberPhone(id, memberPhoneId, data) {
        return this.request(
            "PATCH",
            `${this.getEndpoint()}/${id}/memberPhone/${memberPhoneId}`,
            data
        );
    }

    search(criteria) {
        return this.request(
            "GET",
            `${this.getEndpoint()}/travel-agency/search/${criteria}`,
            null
        );
    }

    searchRegularTraveler(criteria, includes) {
        const queryString = this.buildQueryString({
            includes: includes ?? travelersIncludes,
        });
        return this.request(
            "GET",
            `${this.getEndpoint()}/regular-travelers/search/${criteria}?${queryString}`
        );
    }

    saveAuthorizationCode(authorizationCode, driver) {
        return this.request(
            "POST",
            `${this.getEndpoint()}/authorization-code`,
            { authorization_code: authorizationCode, driver }
        );
    }

    getAuthenticationOptions() {
        return this.request(
            "GET",
            `${this.getEndpoint()}/authentication/options`,
            null
        );
    }

    disconnect(externalIdentifierType) {
        return this.request(
            "POST",
            `${this.getEndpoint()}/authentication/disconnect`,
            { external_identifier_type: externalIdentifierType }
        );
    }
}
